import { render, staticRenderFns } from "./fvPagination.vue?vue&type=template&id=68ecd37a&lang=pug&"
import script from "./fvPagination.vue?vue&type=script&lang=js&"
export * from "./fvPagination.vue?vue&type=script&lang=js&"
import style0 from "./fvPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvPagination.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvPagination.vue
// module id = 191
// module chunks = 0 1